import request from '@/utils/request'

const basePath = '/api/review/result'


/**
 * 根据答题卡id查询批阅结果
 * @param answerSheetId
 * @returns {*}
 */
export function findResultByAnswerSheetId(answerSheetId) {
    return request({
        url: `${basePath}/${answerSheetId}`,
        method: 'GET'
    })
}

/**
 * 更新评分
 * @param data
 */
export function updateScore(data) {
    return request({
        url: `/api/review/result/update`,
        method: 'post',
        data
    })
}

/**
 * 用户题目批阅结果查询
 * @param reviewerQuestionId
 * @returns {*}
 */
export function getQuestionReviewResult(reviewerQuestionId) {
    return request({
        url: `${basePath}/reviewerQuestion/${reviewerQuestionId}`,
        method: 'get'
    })
}